import { postRequest } from "../httpMethods";

// export const postAddLsm = (payload) =>
//     postRequest(`lms/add-course-with-subtopics`, payload);

export const postAddLsm = (payload) =>
    postRequest(`lms/course/topic-subtopics`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });


export const postThreed = (payload) =>
    postRequest(`lms/course/three-d`, payload);

export const postAddLsmSubtopic = (id, payload) =>
    postRequest(`lms/subtopics/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });


export const postAddSubtopicThreejs = (id, payload) =>
    postRequest(`lms/three-d/subtopics/${id}`, payload);


export const postLmsBoards = (payload) =>
    postRequest(`lms/boards`, payload);


export const postLmsGrades = (payload) =>
    postRequest(`lms/grades`, payload);


export const postLmsPublications = (payload) =>
    postRequest(`lms/publications`, payload);


export const postLmsLanguage = (payload) =>
    postRequest(`lms/languages`, payload);

export const postRaisedTicket = (payload) =>
    postRequest(`tickets`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

export const postAssignTrainer = (id, payload) =>
    postRequest(`trainer-assign/${id}/assign`, payload);

export const postTrainerAvailibility = (id, payload) =>
    postRequest(`trainer-assign/${id}/check-availability`, payload);


export const postCreateAssessment = (payload) =>
    postRequest(`assessments`, payload);

export const postLmsSubject = (payload) =>
    postRequest(`subject`, payload);

export const postLmsChapter = (payload) =>
    postRequest(`chapters`, payload);

export const postLmsTopics = (payload) =>
    postRequest(`topics`, payload);


export const postLmsTag = (id, payload) =>
    postRequest(`tags/create/${id}`, payload);

export const postActivityAddLsm = (formData) =>
    postRequest(`v1/lms/activity`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

export const postLmsActivity = (id, payload) =>
    postRequest(`v1/lms/activity/add/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

export const postSaveDraftAiLms = (payload) =>
    postRequest(`v1/ai-lms`, payload);

export const postAilmsUploadImage = (payload) =>
    postRequest(`v1/ai-lms/upload/image`, payload);

export const postDocName = (payload) =>
    postRequest(`v1/document`, payload);


export const postAilmsGenerate = (grade, subject, payload) =>
    postRequest(`grade${grade}/${subject}/tlm`, payload, {
        baseURL: window._env_?.AI_LMS_GENERATE_API
    });